import type { Settings } from '../types';

class SavedSettings {
  value = $state<Array<Settings>>([]);
}

export const savedSettings = new SavedSettings();
